import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Degraded "chat unavailable" surface (SPEC-2026-07-internal-chat, T-25 ·
 * RNF-08 · AC-20).
 *
 * Rendered when the chat backend cannot be reached at all and there is nothing
 * to show (`chatUnavailableSelector`). It is deliberately a plain in-place
 * panel: the chat surfaces are self-contained, so an unreachable chat backend
 * degrades to this message while attendance, CRM and every other screen keep
 * working untouched — no global interceptor, no route guard, no blocking modal.
 *
 * The retry re-dispatches the bootstrap load; it never reloads the page.
 */
@Component({
  selector: 'chat-unavailable',
  templateUrl: './chat-unavailable.component.html',
  styleUrls: ['./chat-state-panel.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatUnavailableComponent {

  /** Tighter spacing/typography for the bubble popup surface. */
  @Input() compact = false;

  @Output() retry = new EventEmitter<void>();
}
